import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader, SelectField } from "@/components/common";
import { InterventionDialog } from "@/components/forms";
import { InterventionsTable } from "@/components/tables";
import { useList } from "@/lib/hooks";
import { INTERVENTION_STATUS, INTERVENTION_TYPES, CATEGORY_LABELS, MODES } from "@/lib/constants";

export default function Interventions() {
  const [status, setStatus] = useState(null);
  const [type, setType] = useState(null);
  const [mode, setMode] = useState(null);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "";
  const { items, reload } = useList("/interventions", { status: status || "", type: type || "", category: cat, mode: mode || "" });
  const shown = items.filter((i) => `${i.title} ${i.client_name} ${i.id}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <>
      <PageHeader title="Interventions" subtitle="Dépannage, installation, configuration, réseau et assistance à distance">
        <Button variant="secondary" onClick={() => setParams({ cat: "in_progress" })} data-testid="in-progress-filter-button">En cours</Button>
        <Button variant="secondary" onClick={() => setParams({ cat: "drafts" })} data-testid="drafts-filter-button">Brouillons</Button>
        <Button variant="secondary" onClick={() => setOpen(true)} data-testid="new-intervention-button"><Plus className="mr-1 h-4 w-4" />Création rapide</Button>
        <Button asChild className="dt-glow"><Link to="/interventions/nouvelle" data-testid="wizard-intervention-button"><Plus className="mr-1 h-4 w-4" />Nouvelle intervention</Link></Button>
      </PageHeader>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Input placeholder="Rechercher (objet, client)…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="interventions-search-input" className="sm:max-w-xs" />
        <SelectField className="sm:w-48" value={status} onChange={setStatus} options={INTERVENTION_STATUS} allowNone="Tous les statuts" testid="interventions-status-filter" />
        <SelectField className="sm:w-56" value={type} onChange={setType} options={INTERVENTION_TYPES} allowNone="Tous les types" testid="interventions-type-filter" />
        <SelectField className="sm:w-48" value={mode} onChange={setMode} options={MODES} allowNone="Tous les modes" testid="interventions-mode-filter" />
      </div>
      {cat && (
        <button onClick={() => setParams({})} data-testid="interventions-category-chip" className="inline-flex items-center gap-1 rounded-full border border-cyan-400/40 bg-cyan-400/10 px-3 py-1 text-sm text-cyan-200">
          Filtre : {CATEGORY_LABELS[cat] || cat} <X className="h-3.5 w-3.5" />
        </button>
      )}
      <InterventionsTable items={shown} reload={reload} />
      <InterventionDialog open={open} onOpenChange={setOpen} initial={{}} onSaved={reload} />
    </>
  );
}
